import clsx from 'clsx';
import React from 'react';
import { textColorStyles, type TextColor } from '../styles/colors';

export interface TitleProps {
  children: React.ReactNode;
  className?: string;
  color?: TextColor;
  size?: 'tiny' | 'small' | 'medium' | 'large';
  as?: 'h1' | 'h2' | 'p';
}

const FONT_FAMILY = 'Inter, sans-serif';
const FONT_WEIGHT = 'var(--font-weight-bold)';

const sizeStyles = {
  tiny: { fontSize: '1.25rem', lineHeight: '1.75rem' },
  small: { fontSize: '1.5rem', lineHeight: '2rem' },
  medium: { fontSize: '1.875rem', lineHeight: '2.25rem' },
  large: { fontSize: '2.25rem', lineHeight: '2.5rem' },
};

export const Title = ({
  children,
  className,
  color = 'primary-black',
  size = 'large',
  as: Component = 'h1',
}: TitleProps) => (
  <Component
    className={clsx(textColorStyles[color], className)}
    style={{
      fontFamily: FONT_FAMILY,
      ...sizeStyles[size],
      fontWeight: FONT_WEIGHT,
    }}
  >
    {children}
  </Component>
);
